<template>
	<div class="text-center">
		<v-btn color="white" outlined class="custom-button" small @click.stop="dialog = true"> Ver Mais </v-btn>
		<v-dialog v-model="dialog" width="720">
			<v-card>
				<v-card-title class="justify-center primary py-2 text-center text-subtitle-1 white--text">
					<span class="font-weight-bold">Dados do Aderente</span>
					<v-spacer></v-spacer>
					<v-icon dark @click="dialog = false"> mdi-close </v-icon>
				</v-card-title>
				<az-container class="ml-6 mr-6">
					<div class="modal-customizado">
						<div class="d-flex flow-row align-content-stretch w-100 justify-space-between">
							<div class="infoCabecalho mr-0">
								<span class="labelModal">Solicitante</span>
								<texto-tooltip
									:texto="(solicitacaoAdesao || {}).nomeCompleto || '---'"
									:tamanho-maximo="25"
								></texto-tooltip>
							</div>

							<div class="infoCabecalho mr-0">
								<span class="labelModal">CNPJ</span>
								<texto-tooltip
									:texto="filtroMascaraCnpj((solicitacaoAdesao || {}).documento) || '---'"
									:tamanho-maximo="25"
								></texto-tooltip>
							</div>

							<div class="infoCabecalho mr-0">
								<span class="labelModal">E-mail</span>
								<texto-tooltip
									:texto="(solicitacaoAdesao || {}).email || '---'"
									:tamanho-maximo="25"
								></texto-tooltip>
							</div>

							<div class="infoCabecalho mr-0">
								<span class="labelModal">Contato</span>
								<texto-tooltip :texto="telefoneMask || '---'" :tamanho-maximo="40"></texto-tooltip>
							</div>
						</div>
					</div>
				</az-container>
				<v-divider></v-divider>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import FormUtils from '@/core/utils/FormUtils'

export default {
	name: 'modal-ver-mais',
	props: {
		solicitacaoAdesao: {
			type: Object,
			default: () => ({}), // valor padrão como um objeto vazio
		},
	},
	emits: ['fechar-modal', 'confirmar'],
	data() {
		return {
			dialog: false,
			filtroMascaraCnpj: this.$options.filters.azCpfCnpj,
		}
	},
	computed: {
		telefoneMask() {
			return FormUtils.aplicarMascaraNumero(this.solicitacaoAdesao.numeroContato)
		},
	},
}
</script>
<style lang="stylus">
.modal-customizado
	display flex
	flex-direction row
	justify-content space-between
	height 70px

	.infoCabecalho
		display flex
		flex-direction column
		justify-items space-evenly
		justify-content space-evenly

	.labelModal
		font-weight bold !important
		font-size 0.95em !important
		color black !important

	.label
		font-weight bold !important
		font-size 0.95em !important
		color white !important

	.item-text
		display inline-flex !important
		font-size .8em !important
		color white !important

	.w-100
		width 100%

	.theme--light.v-btn
		color #FFF !important;

.custom-button {
	text-transform: none !important;
}
</style>
